import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { makeRequest2 } from '../../../../../utils/makeRequest';
import { toastify } from '../../../../../utils/toast';
import { useFacilityStore } from '../../../../../app/z-store/store';

const AlertsTab = () => {
  const [alertsData, setAlertsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState('');
  const facilityId = useFacilityStore(state => state.selectedFacilityId);

  useEffect(() => {
    if (facilityId) {
      fetchAlertsData();
    }
  }, [facilityId]);

  const fetchAlertsData = async () => {
    if (!facilityId) return;

    setLoading(true);
    try {
      
      let endpoint = `/api/common-area/alerts/${facilityId}`;
      
      if (dateFilter) {
        endpoint += `?date=${dateFilter}`;
      }
      
      const response = await makeRequest2(endpoint, 'GET');

      if (response.success && response.data && response.data.alerts) {
        setAlertsData(response.data.alerts);
      } else {
        setAlertsData([]);
      }
    } catch (error) {
      toastify("Failed to load alerts data", "error");
      setAlertsData([]);
    } finally {
      setLoading(false);
    }
  };

  const filterDataByDate = () => {
    fetchAlertsData();
  };

  const formatDate = (rowData) => {
    if (!rowData.date) return '';
    const date = new Date(rowData.date);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  };
  const statusTemplate = (rowData) => {
    const status = rowData.status?.toLowerCase() || '';
    let badgeClass = 'badge ';
    
    switch(status) {
      case 'critical':
        badgeClass += 'bg-danger';
        break;
      case 'warning':
        badgeClass += 'bg-warning text-dark';
        break;
      case 'resolved':
        badgeClass += 'bg-success';
        break;
      case 'pending':
        badgeClass += 'bg-info';
        break;
      default:
        badgeClass += 'bg-secondary';
    }
    
    return <span className={badgeClass}>{rowData.status}</span>;
  };

  const utilityTypeTemplate = (rowData) => {
    const type = rowData.utilityType?.toLowerCase() || '';
    let icon = '';
    
    switch(type) {
      case 'generator':
        icon = 'ti ti-engine';
        break;
      case 'water':
        icon = 'ti ti-droplet';
        break;
      case 'electricity':
        icon = 'ti ti-bulb';
        break;
      default:
        icon = 'ti ti-alert-circle';
    }
    
    return (
      <div>
        <i className={icon + ' me-2'}></i>
        {rowData.utilityType}
      </div>
    );
  };

  return (
    <>
      <div className="mb-4">
        <div className="card">
          <div className="card-body d-flex align-items-center">
            <span className="me-2">Filter by Date:</span>
            <InputText
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              placeholder="Filter by Date"
            />
            <Button
              icon="ti ti-search"
              className="ms-2"
              onClick={filterDataByDate}
              tooltip="Search"
            />
            <Button
              icon="ti ti-refresh"
              className="ms-2"
              onClick={() => {
                setDateFilter('');
                fetchAlertsData();
              }}
              tooltip="Reset"
            />
          </div>
        </div>
      </div>

      <DataTable
        value={alertsData}
        loading={loading}
        paginator
        rows={10}
        emptyMessage="No alerts found"
        stripedRows
        sortMode="multiple"
        removableSort
        tableStyle={{ minWidth: '50rem' }}
      >
        <Column body={formatDate} header="Date" sortable field="date" />
        <Column body={utilityTypeTemplate} header="Utility Type" sortable field="utilityType" />
        <Column field="description" header="Description" sortable />
        <Column body={statusTemplate} header="Status" sortable field="status" />
      </DataTable>
    </>
  );
};

export default AlertsTab;